import React from 'react';
import { Panel, Tag } from 'rsuite';
import type { BagelAiFlowNode, BagelAiFlowRoute } from '../../types/aiFlow';
import FLOW_NODE_KIND_LABEL from '../../utils/flowNodeKindLabels';
import RouteList from './RouteList';

type Props = {
  node: BagelAiFlowNode;
  routes?: BagelAiFlowRoute[];
};

/** Read-only detail view for nodes with no bound prompt (gates, skills, tools, input/output). */
export default function NodeInfoPanel({ node, routes = [] }: Props) {
  return (
    <Panel
      bordered
      header={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 600 }}>{node.title}</span>
          <Tag>{FLOW_NODE_KIND_LABEL[node.kind]}</Tag>
        </div>
      }
    >
      <p style={{ margin: 0, fontSize: 13, color: '#334155', lineHeight: 1.5 }}>
        {node.description}
      </p>
      {node.tools && node.tools.length > 0 ? (
        <div style={{ marginTop: 12, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {node.tools.map(tool => (
            <Tag key={tool.name} color="orange">
              {tool.name}
            </Tag>
          ))}
        </div>
      ) : null}
      <RouteList routes={routes} />
    </Panel>
  );
}
